"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClaimResourceInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const claimResourceStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['vaultOwnerBump', beet.u8],
], 'ClaimResourceInstructionArgs');
const claimResourceInstructionDiscriminator = [0, 160, 164, 96, 237, 118, 74, 27];
function createClaimResourceInstruction(accounts, args) {
    const { market, treasuryHolder, sellingResource, sellingResourceOwner, vault, metadata, owner, destination, clock, tokenMetadataProgram, } = accounts;
    const [data] = claimResourceStruct.serialize({
        instructionDiscriminator: claimResourceInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: market,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: treasuryHolder,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: sellingResource,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: sellingResourceOwner,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: vault,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: metadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: owner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: destination,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: clock,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: tokenMetadataProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('SaLeTjyUa5wXHnGuewUSyJ5JWZaHwz3TxqUntCE9czo'),
        keys,
        data,
    });
    return ix;
}
exports.createClaimResourceInstruction = createClaimResourceInstruction;
//# sourceMappingURL=claimResource.js.map